import { cloneDeep } from 'lodash';
import * as _ from 'lodash'
import * as echarts from "echarts";
import { element } from 'protractor';

export const barChart_series: any[] = [
  {
    name: "",
    type: "bar",
    barGap: "50%",
    barCategoryGap: "30%",
    barMaxWidth: 11,
    data: [],
    label: {
      show: true,
      position: "right",
      fontSize: 11,
      fontWeight: "bold",
      color: "#333333",
    },
  },
];

export const symbols = [
  "circle",
  "rect",
  "roundRect",
  "triangle",
  "diamond",
  "pin",
  "arrow",
];
export const getBasicLineChartSeries = function (
  datas: any[][],
  seryNames: any[],
  markLineData: { [key: string]: any }[][] = [],
  markAreaData: { [key: string]: any }[][][] = [],
  markPointData = []
) {
  let series = [];
  for (let i = 0; i < seryNames.length; i++) {
    let sery = {
      name: seryNames[i],
      type: "line",
      symbol: symbols[i % symbols.length],
      symbolSize: 4,
      barGap: 0,
      smooth: 0.2,
      label: {
        show: false,
        position: "left",
        formatter: function (params) {
          if (datas[i].length - 1 == params.dataIndex) {
            return params.seriesName;
          } else {
            return "";
          }
        },
      },
      lineStyle: {
        width: 1.5
      },
      data: datas[i],
      markLine: {
        symbol: "none",
        label: {
          position: "insideEndTop",
        },
        data: [],
        tooltip: {
          show: false,
        },
      },
      markArea: {
        label: {
          position: "insideTop"
        },
        silent: true,
        itemStyle: {
          // borderWidth: 0,
        },
        data: [],
      },
      markPoint: {
        symbol: "pin",
        symbolSize: 45,
        data: [],
        tooltip: {
          show: false,
          // formatter: function(param) {
          //   console.log("param", param);
          // }
        },
        label: {
          formatter: function (params) {
            return params.data.coord[1];
          }
        }
      }
    };
    if (markLineData[i]) {
      sery.markLine.data = markLineData[i];
    }
    if (markAreaData[i]) {
      sery.markArea.data = markAreaData[i];
    }
    if (markPointData[i]) {
      sery.markPoint.data = markPointData[i];
    }
    series.push(sery);
  }
  return series;
};
export const getBasicLineChartSeriesWithoutData = () => {
  return [];
};

export const getMoreLineChartSeries = function (
  datas: any[][],
  seryNames: any[],
  markArea,
  markLine: { [key: string]: any }[][] = []
) {
  let series = [];
  for (let i = 0; i < seryNames.length; i++) {
    let sName = seryNames[i].split("(").length == 1 ? seryNames[i] : seryNames[i].split("(")[0];
    let sery = {
      name: sName,
      type: "line",
      symbol: symbols[i % symbols.length],
      symbolSize: 2,
      smooth: 0.2,
      lineStyle: {
        width: 1,
      },
      label: {
        show: false,
        fontWeight: "bold",
        color: "#000000",
      },
      data: datas[i],
      markLine: {
        symbol: "none",
        label: {
          position: "insideEndTop",
        },
        data: [],
        tooltip: {
          show: false,
        },
      },
    };

    if (markLine[i]) {
      sery.markLine.data = markLine[i];
    }

    series.push(sery);
  }
  if (markArea) {
    series.push({
      type: 'line',
      markArea: markArea
    });
  }
  return series;
};

export const getDefaultLineChartSeries = function () {
  let seriesItem = {
    name: '',
    type: "line",
    // symbol: symbols[i % symbols.length],
    symbolSize: 2,
    smooth: 0.2,
    lineStyle: {
      width: 1,
    },
    label: {
      show: false,
      fontWeight: "bold",
      color: "#000000",
    },
    data: [],
    markArea: {
      label: {
        position: "insideTop"
      },
      silent: true,
      itemStyle: {
        borderWidth: 1,
      },
      data: [],
    },
  };
  return seriesItem;
};

export const getBigDataLineChartSeries = function (
  datas: any[][][],
  seriesNames: any[]
) {
  let series = [];
  for (let i = 0; i < seriesNames.length; i++) {
    let sery = {
      name: seriesNames[i],
      type: "line",
      symbol: symbols[i % symbols.length],
      symbolSize: 0.8,
      lineStyle: {
        width: 0.8,
      },
      data: datas[i],
    };
    series.push(sery);
  }
  return series;
};

export const getAnnotationsLineChartSeries = function (
  datas: any[][][],
  seriesNames: any[],
  markPoints: any[]
) {
  let series = [];
  for (let i = 0; i < seriesNames.length; i++) {
    let sery = {
      name: seriesNames[i],
      type: "line",
      symbol: symbols[i % symbols.length],
      symbolSize: 1.2,
      lineStyle: {
        width: 1.2,
      },
      // itemStyle: {
      //   shadowOffsetX: 2,
      //   shadowOffsetY: 2
      // },
      emphasis: {
        itemStyle: {
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      },
      data: datas[i],
      areaStyle: {
        opacity: 0.5,
      },
      smooth: 0.8,
      markPoint: {
        data: markPoints[i],
        symbol: "circle",
        symbolSize: 8,
        label: {
          show: true,
          position: "right",
          distance: 5,
          color: "#000000",
          formatter: function (param) {
            return param.data.name;
          },
          backgroundColor: "#FFFFFF",
          borderColor: "#7cb5ec",
          borderWidth: 0.4,
          padding: 5,
          borderRadius: 2,
        },
        itemStyle: {
          // color: "#020A0F",
          borderColor: "#4D4D4D",
          borderWidth: 0.5,
        },
      },
    };
    series.push(sery);
  }
  return series;
};

export const getNegativeBarChartSeries = function (
  datas: any[][][],
  seriesNames: any[],
  translationNumber: number = 0
) {
  let series = [];
  for (let i = 0; i < seriesNames.length; i++) {
    let sery = {
      name: seriesNames[i],
      type: "bar",
      // symbol: symbols[i % symbols.length],
      // symbolSize: 1.2,
      // lineStyle: {
      //   width: 1.2,
      // },
      // itemStyle: {
      //   shadowOffsetX: 2,
      //   shadowOffsetY: 2
      // },
      emphasis: {
        itemStyle: {
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      },
      cursor: "pointer",
      barMaxWidth: 15,
      barGap: "35%",
      large: true,
      largeThreshold: 400,

      data: datas[i].map((element) => {
        return [element[0], (+element[1] - translationNumber).toFixed(1)];
      }),
      // areaStyle: {
      //   opacity: 0.5,
      // },
      // smooth: 0.8,
      // markPoint: {
      //   data: markPoints[i],
      //   symbol: "circle",
      //   symbolSize: 8,
      //   label: {
      //     show: true,
      //     position: "right",
      //     distance: 5,
      //     color: "#000000",
      //     formatter: function (param) {
      //       return param.data.name;
      //     },
      //     backgroundColor: "#FFFFFF",
      //     borderColor: "#7cb5ec",
      //     borderWidth: 0.4,
      //     padding: 5,
      //     borderRadius: 2,
      //   },
      //   itemStyle: {
      //     // color: "#020A0F",
      //     borderColor: "#4D4D4D",
      //     borderWidth: 0.5,
      //   },
      // },
    };
    series.push(sery);
  }
  return series;
};
export const getNegativeBarChartSeriesDefault = function () {
  return [];
};
// 基础柱状图
export function getColumnChartSeries(style, data?) {
  const columnChartSeries = {
    name: "",
    type: "bar",
    barGap: "10%",
    data: [],
    barMaxWidth: 12,
    showBackground: false,
    label: {
      fontSize: style.fontSize - 1,
    },
    markLine: {
      symbol: "none",
      symbolSize: style.markLineSymbolSize,
      label: {
        position: 'insideEndBottom'
      },
      data: [],
    },
    markArea: {
      label: {
        position: 'inside',
        fontSize: style.fontSize - 2,
        emphasis: {
          position: 'inside'
        }
      },
      data: []
    }
  };
  if (!data) {
    return [cloneDeep(columnChartSeries)];
  }

  let seriesArr = [];
  if (data && data.hasOwnProperty('seriesName')) {
    for (let i = 0; i < data.seriesName.length; i++) {
      let markLineArr = [];
      let markAreaArr = [];
      let columnSeries = cloneDeep(columnChartSeries);
      columnSeries.name = data.seriesName[i];

      columnSeries.data = data.yData[i]
      seriesArr.push(columnSeries)
      if (Object.prototype.hasOwnProperty.call(data, 'markLine')) {
        markLineArr = data.markLine[i]
      }
      columnSeries.markLine.data = markLineArr;

      if (Object.prototype.hasOwnProperty.call(data, 'markArea')) {
        markAreaArr = data.markArea[i]
      }
      columnSeries.markArea.data = markAreaArr;
    }
  }
  return seriesArr;
}
export function getBarLineSeries(style, data?) {
  if (!data) {
    return [];
  }
  const columnChartSeries = {
    name: "",
    type: "bar",
    barGap: "10%",
    data: [],
    barMaxWidth: 30,
    label: {
      fontSize: style.fontSize - 1,
    },
    yAxisIndex: 0
  };
  const lineSery = {
    name: "",
    type: "line",
    symbol: symbols[0],
    symbolSize: 2,
    smooth: 0.2,
    lineStyle: {
      width: 1,
    },
    label: {
      show: false,
      fontWeight: "600",
      color: "#000000",
    },
    yAxisIndex: 1,
    data: [],
  };
  let seriesArr = [];
  for (let i = 0; i < data.seriesName.length; i++) {
    if (data.seriesName[i].type === "line") {
      let lineSeries = cloneDeep(lineSery);
      lineSeries.name = data.seriesName[i].name;
      lineSeries.symbol = symbols[i % symbols.length];
      lineSeries.data = data.yData[i];
      seriesArr.push(lineSeries);
    } else {
      let columnSeries = cloneDeep(columnChartSeries);
      columnSeries.name = data.seriesName[i].name;
      columnSeries.data = data.yData[i];
      seriesArr.push(columnSeries);
    }
  }
  return seriesArr;
}

export function getBarChartSeries(style, data?, tooltipUnit = "", labelUnitSwitch: boolean = true) {
  if (!data) {
    return [];
  }
  const barChartSeries = {
    name: "",
    type: "bar",
    barGap: "50%",
    barCategoryGap: "30%",
    barMaxWidth: 10,
    data: [],
    label: {
      show: true,
      position: "right",
      fontSize: style.fontSize - 2,
      fontWeight: "bold",
      color: "#333333",
      formatter: `{c} ${tooltipUnit}`
    },
  };
  let seriesArr = [];
  if (data.hasOwnProperty('seriesName')) {
    for (let i = 0; i < data.seriesName.length; i++) {
      let barSeries = cloneDeep(barChartSeries);
      if (labelUnitSwitch == false) {
        barSeries.label.formatter = '{c}'
      }
      barSeries.name = data.seriesName[i];
      barSeries.data = data.xData[i];
      seriesArr.push(barSeries);
    }
  }
  return seriesArr;
}

// 基础条形图（横向）
export function getDefaultBarChartSeries(style) {
  const barChartSeries = {
    name: "",
    type: "bar",
    barGap: "50%",
    barCategoryGap: "30%",
    barMaxWidth: 10,
    data: [],
    label: {
      show: true,
      position: "top",
      fontSize: style.fontSize - 2,
      fontWeight: "bold",
      color: "#333333",
      // formatter: `{c} ${tooltipUnit}`
    },
    markLine: {
      label: {
        position: 'insideEndBottom'
      },
      data: [],
    },
    markArea: {
      label: {
        position: 'inside',
        fontSize: style.fontSize - 2,
        emphasis: {
          position: 'inside'
        }
      },
      data: []
    }
  };
  // let seriesArr = [];
  // for (let i = 0; i < data.seriesName.length; i++) {
  //   let barSeries = cloneDeep(barChartSeries);
  //   barSeries.name = data.seriesName[i];
  //   barSeries.data = data.xData[i];
  //   seriesArr.push(barSeries);
  // }
  return barChartSeries;
}
// 分组堆叠柱状图
export function getStackBarChartSeries(data?) {
  if (!data) {
    return [];
  }
  const stackBarChartSeries = {
    name: "",
    type: "bar",
    stack: "",
    barGap: "50%",
    barMaxWidth: 10,
    data: [],
  };
  let seriesArr = [];
  if (data.seriesName) {
    for (let i = 0; i < data.seriesName.length; i++) {
      let stackBarSeries = cloneDeep(stackBarChartSeries);
      stackBarSeries.name = data.seriesName[i];
      stackBarSeries.stack = data.stack[i];
      stackBarSeries.data = data.yData[i];
      seriesArr.push(stackBarSeries);
    }
  }
  return seriesArr;
}
// 金字塔图
export function getPyramidBarChartSeries(data: { seriesName: string[], xData: string[][], yData: string[][], stack: string } = { xData: [], yData: [], seriesName: [], stack: "" }) {
  const pyramidBarChartSeries = {
    name: "",
    type: "bar",
    stack: "",
    yAxisIndex: 0,
    barMaxWidth: 15,
    barCategoryGap: "50%",
    data: [],
  };
  let pyramidSeries = [];
  data.xData.forEach((item, index) => {
    let partOfSeries = cloneDeep(pyramidBarChartSeries);
    partOfSeries.name = data.seriesName[index];
    partOfSeries.stack = data.stack;
    partOfSeries.data = item;
    partOfSeries.yAxisIndex = index;
    pyramidSeries.push(partOfSeries);
  });
  return pyramidSeries;
}
// 获取基础饼图系列配置（不含图例）
export function getBasicPieChartSeries(
  style,
  data: { name: string; value: string | number }[] = [],
  seriesName: string = "seriesName"
) {
  const basicPieChartSeries = [
    {
      name: seriesName,
      type: "pie",
      minAngle: 15,
      radius: "60%",
      center: ["50%", "50%"],
      selectedMode: "single",
      selectedOffset: 20,
      data: data,
      label: {
        fontSize: style.fontSize - 1,
        formatter: "{b}: {d} %",

        alignTo: "none",
        color: "#333333",
        fontWeight: "bold",
      },
      labelLine: {
        smooth: true,
        length: 10,
        length2: 10,
      },
      hoverOffset: 5,
      emphasis: {
        itemStyle: {
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsety: 10,
        },
      },
    },
  ];
  return basicPieChartSeries;
}
// 获取带图例饼图系列配置
export function getLegendPieChartSeries(
  style,
  data: { name: string; value: string | number }[] = [],
  seriesName: string = "seriesName"
) {
  const legendPieChartSeries = [
    {
      name: seriesName,
      type: "pie",
      minAngle: 0,
      radius: "60%",
      center: ["50%", "50%"],
      selectedMode: "single",
      selectedOffset: 20,
      data: data,
      label: {
        show: true,
        fontSize: style.fontSize - 1,
        // formatter: "{b}: {d} %",
        formatter: (param) => {
          let str = '';
          str = param.name + ' : ' + param.percent.toFixed(1) + '%';
          return str;
        },

        alignTo: "none",
        color: "#333333",
        fontWeight: "bold",
      },
      labelLine: {
        smooth: true,
        length: 10,
        length2: 10,
      },
      hoverOffset: 5,
      emphasis: {
        itemStyle: {
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsety: 10,
        },
      },
      animationDurationUpdate: 600,
    },
  ];
  return legendPieChartSeries;
}

// 获取玫瑰图饼图系列配置
export function getRosePieChartSeries(
  style,
  data: { name: string; value: string | number }[] = [],
  roseType: "radius" | "area" = "radius",
  seriesName: string = "seriesName"
) {
  const legendPieChartSeries = [
    {
      name: seriesName,
      type: "pie",
      radius: ["40%", "60%"],
      center: ["50%", "50%"],
      roseType: roseType,
      selectedMode: "single",
      selectedOffset: 20,
      data: data,
      label: {
        show: true,
        fontSize: style.fontSize - 2,
        formatter: (params) => {
          let str = '';
          str = params.name + ' : ' + params.percent.toFixed(1) + '%';

          return str;
        },

        alignTo: "none",
        color: "#333333",
        fontWeight: "bold",
      },
      labelLine: {
        smooth: true,
        length: 10,
        length2: 5,
      },
      hoverOffset: 5,
      emphasis: {
        label: {
          show: true,
        },
        itemStyle: {
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsety: 10,
        },
      },
      animationDurationUpdate: 600,
    },
  ];
  return legendPieChartSeries;
}
//todo 声学分析系列配置
export function geSeriesOfNoiseAnalysisLine(data: any, colorMap) {
  let cubeData = []
  let monitorItem = []
  let monitorItemDefaultShow = []
  if (data.toolboxDatas && data.toolboxDatas.multipleChoiceData) {
    data.toolboxDatas.multipleChoiceData.map((item) => {
      monitorItem.push(item.value)
      if (item.ischecked) {
        monitorItemDefaultShow.push(item.value)
      }
    })
  }
  for (const item in colorMap) {
    cubeData.push({
      name: item,
      type: 'bar',
      itemStyle: {
        color: colorMap[item]
      },
      data: [],
      xAxisIndex: 1,
      yAxisIndex: 1
    })
  }
  if (data.rectsDataLists) {
    data.rectsDataLists = data.rectsDataLists.map((item) => {
      return {
        ...item,
        itemStyle: {
          normal: {
            color: colorMap[item.name]
          }
        }
      }
    })
  }
  let renderItem = (params, api) => {
    var categoryIndex = api.value(0);
    var start = api.coord([api.value(1), categoryIndex]);
    var end = api.coord([api.value(2), categoryIndex]);
    var height = api.size([0, 1])[1] * 0.7;

    var rectShape = echarts.graphic.clipRectByRect({
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0],
      height: height
    }, {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    });

    return rectShape && {
      type: 'rect',
      shape: rectShape,
      style: api.style()
    };
  }
  let merdata: any = [{
    name: 'custom',
    type: 'custom',
    renderItem: renderItem,
    itemStyle: {
      opacity: 0.8
    },
    encode: {
      x: [1, 2],
      y: 0
    },
    data: data.rectsDataLists,
    xAxisIndex: 1,
    yAxisIndex: 1
  }]
  let seriesdata: any = [{
    name: 'brush',
    type: 'bar',
    data: data.xAxisDatas,
    yAxisIndex: 3,
    itemStyle: {
      opacity: 0
    }
  }]
  for (const item of monitorItem) {
    if (monitorItemDefaultShow.includes(item)) {
      seriesdata.push({
        name: item,
        type: 'line',
        symbol: 'circle',
        yAxisIndex: 0,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1//设置线条粗细
            }
          }
        },
        data: data.yAxisDatas[item]
      })
    }
  }
  let finalseriesdata = merdata.concat(cubeData, seriesdata)
  return finalseriesdata

}




//todo 声学分析系列配置
export function geSeriesOfNoiseAnalysisBlock(data: any, colorMap) {
  let cubeData = []
  for (const item in colorMap) {
    cubeData.push({
      name: item,
      type: 'bar',
      itemStyle: {
        color: colorMap[item]
      },
      data: [],
      xAxisIndex: 1,
      yAxisIndex: 1
    })
  }
  if (data.rectsDataLists) {
    data.rectsDataLists = data.rectsDataLists.map((item) => {
      return {
        ...item,
        itemStyle: {
          normal: {
            color: colorMap[item.name]
          }
        }
      }
    })
  }
  let renderItem = (params, api) => {
    var categoryIndex = api.value(0);
    var start = api.coord([api.value(1), categoryIndex]);
    var end = api.coord([api.value(2), categoryIndex]);
    var height = api.size([0, 1])[1] * 0.7;

    var rectShape = echarts.graphic.clipRectByRect({
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0],
      height: height
    }, {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    });

    return rectShape && {
      type: 'rect',
      shape: rectShape,
      style: api.style()
    };
  }
  let merdata: any = [{
    name: 'custom',
    type: 'custom',
    renderItem: renderItem,
    itemStyle: {
      opacity: 0.8
    },
    encode: {
      x: [1, 2],
      y: 0
    },
    data: data.rectsDataLists,
    xAxisIndex: 1,
    yAxisIndex: 1
  }]
  let seriesdata: any = [{
    name: 'brush',
    type: 'bar',
    data: data.xAxisDatas,
    yAxisIndex: 3,
    itemStyle: {
      opacity: 0
    }
  }]
  let allseriesdata = _.cloneDeep(seriesdata)

  for (const item of data.seriesDatas) {
    allseriesdata.push({
      name: item.categoryName,
      nameId: item.nameId,
      type: 'line',
      symbol: 'circle',
      yAxisIndex: 0,
      itemStyle: {
        normal: {
          lineStyle: {
            width: 1//设置线条粗细
          }
        }
      },
      data: item.data
    })
    if (item.isChecked) {
      seriesdata.push({
        name: item.categoryName,
        type: 'line',
        symbol: 'circle',
        yAxisIndex: 0,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1//设置线条粗细
            }
          }
        },
        data: item.data
      })
    }
  }
  let finalseriesdata = merdata.concat(cubeData, seriesdata)
  let allfinalseriesdata = merdata.concat(cubeData, allseriesdata)
  let res = {
    series: finalseriesdata,
    allseries: allfinalseriesdata
  }
  return res

}

// 获取地图散点图的系列
export function getScatterOfMapSeries(style) {
  const scatterSeries = {
    type: 'scatter',
    coordinateSystem: 'geo',
    data: [],
    symbolSize: style.fontSize - 2,
    emphasis: {
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 1
      }
    },
    label: {
      show: false,
      position: "top",
      formatter: '{b}',
      color: "#101010",
      fontSize: style.fontSize - 2
    }
  }
  return scatterSeries
}
// Bar3D系列
export function getBar3DSeries(style) {
  let series = {
    type: "bar3D",
    // name: "达标率",
    coordinateSystem: "geo3D",
    shading: "lambert",
    // data: [],
    // bevelSmoothness: 100,   //倒角光滑度
    barSize: 0.75,    //柱形粗细
    bevelSize: 0.5,    //柱形倒角
    minHeight: 0.05,   //最小高度
    maxHeight: 20,
    itemStyle: {
      opacity: 0.8,
    },
    label: {
      show: true,
      distance: 0,
      formatter: (param) => {
        let temArr = [...param.name];
        temArr.splice(-1, 1);
        return temArr.join("");
      },
      textStyle: {
        color: "#1c1b1b",
        fontSize: style.fontSize - 2,
        opacity: 1,
        backgroundColor: "rgba(255,255,255,0.8)",
      },
    },
    emphasis: {
      label: {
        show: true,
      },
    },
    tooltip: {
      show: true,
      textStyle: {
        fontSize: style.fontSize - 2,
      },

    },
  }
  let tempArr = [];
  tempArr.push(series)
  return tempArr;
}

//todo 声学分析带下拉框系列配置
export function geSeriesOfNoiseDropLine(data: any) {
  let seriesdata = []
  for (const item of data.seriesDatas) {
    if (data.toolboxDatas
      && data.toolboxDatas.toolboxItem
      && data.toolboxDatas.toolboxItem.includes('switchSingleChoice')
      && data.toolboxDatas.toolboxItem.includes('switchMultipleChoice')
      && data.toolboxDatas.multipleChoiceData
      && data.toolboxDatas.singleChoiceData) { //-------------------------
      let multipleCheckedValue = []
      let singleCheckedValue = []
      for (const item of data.toolboxDatas.multipleChoiceData) {
        if (item.ischecked) {
          multipleCheckedValue.push(item.value)
        }
      }
      for (const item of data.toolboxDatas.singleChoiceData) {
        if (item.ischecked) {
          singleCheckedValue.push(item.value)
        }
      }
      if (multipleCheckedValue.includes(item.nameId)
        && singleCheckedValue[0] == item.property) {
        if (item.customRender) {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'custom',
            renderItem: item.customRender,
            smooth: true,
            "z": 10,
            data: item.data,
          })
        } else {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'line',
            symbol: 'circle',//实心
            smooth: true,
            data: item.data,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1//设置线条粗细
                }
              }
            },
          })
        }
      }
    } else if (data.toolboxDatas
      && data.toolboxDatas.toolboxItem
      && data.toolboxDatas.toolboxItem.includes('switchMultipleChoice')
      && !data.toolboxDatas.toolboxItem.includes('switchSingleChoice')
      && data.toolboxDatas.multipleChoiceData
      && !data.toolboxDatas.singleChoiceData) {
      let multipleCheckedValue = []
      for (const item of data.toolboxDatas.multipleChoiceData) {
        if (item.ischecked) {
          multipleCheckedValue.push(item.value)
        }
      }
      if (multipleCheckedValue.includes(item.nameId)) {
        if (item.customRender) {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'custom',
            renderItem: item.customRender,
            smooth: true,
            "z": 10,
            data: item.data,
          })
        } else {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'line',
            symbol: 'circle',//实心
            smooth: true,
            data: item.data,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1//设置线条粗细
                }
              }
            },
          })
        }

      }
    } else if (data.toolboxDatas
      && data.toolboxDatas.toolboxItem
      && !data.toolboxDatas.toolboxItem.includes('switchMultipleChoice')
      && data.toolboxDatas.toolboxItem.includes('switchSingleChoice')
      && !data.toolboxDatas.multipleChoiceData
      && data.toolboxDatas.singleChoiceData) {
      let singleCheckedValue = []
      data.toolboxDatas.singleChoiceData.map((item) => {
        if (item.ischecked) {
          singleCheckedValue.push(item.value)
        }
      })
      if (singleCheckedValue[0] == item.property) {
        if (item.customRender) {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'custom',
            renderItem: item.customRender,
            smooth: true,
            "z": 10,
            data: item.data,
          })
        } else {
          seriesdata.push({
            name: item.name,
            value: item.nameId,
            type: 'line',
            symbol: 'circle',//实心
            smooth: true,
            data: item.data,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1//设置线条粗细
                }
              }
            },
          })
        }
      }
    } else {
      if (item.customRender) {
        seriesdata.push({
          name: item.name,
          value: item.nameId,
          type: 'custom',
          renderItem: item.customRender,
          smooth: true,
          "z": 10,
          data: item.data,
        })
      } else {
        seriesdata.push({
          name: item.name,
          value: item.nameId,
          type: 'line',
          symbol: 'circle',//实心
          smooth: true,
          data: item.data,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1//设置线条粗细
              }
            }
          },
        })
      }
    }
  }
  return seriesdata

}

// 获取map系列
export function getMapSeries() {
  const mapSeries = [{
    type: 'map',
    roam: true,
    geoIndex: 0
  }]

  return mapSeries;
}

// 获取 行政区地图scatter系列
export function getDistrictScatterSeries(style) {
  const series = [{
    type: 'effectScatter',
    coordinateSystem: 'geo',
    showEffectOn: 'emphasis',
    label: {
      show: true,
      fontSize: style.fontSize - 2,
      color: '#000',
      textShadowColor: '#fff',
      textShadowBlur: 2,
      position: 'top',
      formatter: '{b}'
    },
    data: [],
  }]
  return series;
}

// 获取双轴柱状图系列
export function getDoubleYaxisColumnChartSeries(style, data?) {
  const doubleYaxisColumnChartSeries = {
    name: "",
    type: "bar",
    barGap: 0,
    data: [],
    yAxisIndex: 0,
    barMaxWidth: 12,
    label: {
      fontSize: style.fontSize - 1,
    },
    // markLine: {
    //   symbol: "none",
    //   symbolSize: style.markLineSymbolSize,
    //   label: {
    //     position: 'insideEndBottom'
    //   },
    //   data: [],
    // },
  }
  if (!data) {
    return cloneDeep([doubleYaxisColumnChartSeries]);
  }

  let seriesArr = [];
  // for (let i = 0; i < data.seriesName.length; i++) {
  //   let markLineArr = [];
  //   let columnSeries = cloneDeep(doubleYaxisColumnChartSeries);
  //   columnSeries.name = data.seriesName[i];

  //   columnSeries.data = data.yData[i]
  //   seriesArr.push(columnSeries)
  //   if (Object.prototype.hasOwnProperty.call(data, 'markLine')) {
  //     markLineArr = data.markLine[i]
  //   }
  //   columnSeries.markLine.data = markLineArr;
  // }
  // return seriesArr;

  for (let i = 0; i < data.seriesName.length; i++) {
    for (let j = 0; j < data.seriesName[i].length; j++) {
      let markLineArr = [];
      let columnSeries = cloneDeep(doubleYaxisColumnChartSeries);
      columnSeries.name = data.seriesName[i][j];

      columnSeries.yAxisIndex = i;
      columnSeries.data = data.yData[i][j];
      seriesArr.push(columnSeries)
      // if (Object.prototype.hasOwnProperty.call(data, 'markLine')) {
      //   markLineArr = data.markLine[i]
      // }
    }
  }
  return seriesArr;
}
//环状饼图series
export function getRingPieSeries(style, value) {
  if (value && value.hasOwnProperty('total') && value.hasOwnProperty('data')) {
    let surplus = (+value.total - (+value.data)); //剩余值
    if (surplus < 0) {
      surplus = 0;
    }

    if (value.total == null || value.data == null || value.data == 0 || value.total == 0) {
      value.data = null
    }

    return {
      name: value.name,
      type: 'pie',
      clockWise: true,
      radius: [30, 40],
      itemStyle: {
        normal: {
          color: value.color[0],
          shadowColor: value.color[0],
          shadowBlur: 0,
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
        }
      },
      hoverAnimation: false,
      center: ['50%', '45%'],
      data: [{
        value: value.data,
        label: {
          normal: {
            formatter: function (params) {
              if (!_.isNil(value.total) && value.total != 0) {
                return (params.value ? params.value : 0) + '\n' + (params.value / value.total * 100).toFixed(0) + '%';
              } else {
                return (params.value ? params.value : 0) + '\n' + '--'
              }
            },
            position: 'center',
            show: true,
            textStyle: {
              fontSize: style.fontSize,
              fontWeight: 'bold',
              color: value.color[0]
            }
          }
        },
      }, {
        value: surplus,
        name: 'invisible',
        itemStyle: {
          normal: {
            color: value.color[1]
          },
          emphasis: {
            color: value.color[1]
          }
        }
      }]
    }
  }
}

// 获取箱线图系列
export function getDefaultBoxPlotSeries() {
  let boxPlotSeries = {
    name: "",
    type: "boxplot",
    data: [],
    boxWidth: [7, 20],
    yAxisIndex: 0
  }
  return boxPlotSeries;
}
// 获取散点系列
export function getDefaultScatterSeries() {
  let scatterSeries = {
    name: "",
    type: "scatter",
    data: [],
    yAxisIndex: 0,
    symbolSize: 4
  }
  return scatterSeries;
}
// 比较图 自定义系列  
export function getCompareCustomSeries(minVal: number = 0) {
  var renderItem = (params, api) => {
    var xValue = _.isNaN(api.value(0)) ? 0 : api.value(0); //index 0 1 2
    var yValue = _.isNaN(api.value(1)) ? 0 : api.value(1); //currentSd
    var changeValue = _.isNaN(api.value(2)) ? 0 : api.value(2) //变化值
    // var yStartPot = minVal - (minVal % 5);
    var plusOrminus = changeValue > 0 ? 1 : -1;

    var barPoint = api.coord([xValue, yValue]);

    var height = api.size([barPoint, changeValue])[1] * plusOrminus;

    var lineHighPoint = api.coord([xValue, yValue]);
    var lineLowPoint = api.coord([xValue, 0]);
    var style = api.style();

    return {
      type: "group",
      children: [
        {
          type: "line",
          shape: {
            x1: lineHighPoint[0],
            y1: lineHighPoint[1],
            x2: lineLowPoint[0],
            y2: lineLowPoint[1],
          },
          style: api.style({
            stroke: "#a1935f",
          }),
          z: 100,
        },
        {
          type: "rect",
          shape: {
            x: barPoint[0] - 4,
            y: barPoint[1],
            width: 8,
            height: height,
          },
          style: style,
          z: 200,
        },
      ],
    };
  };
  let customSeries = {
    type: 'custom',
    name: '',
    itemStyle: {
      borderWidth: 1
    },
    clip: true,
    renderItem: renderItem,
    encode: {
      x: 0,
      y: [1],
      tooltip: [2],
    },
    data: [],
    z: 10
  }
  return customSeries;
}
export function getGaugeSeries(data) {
  return [{
    min: data.min ? data.min : 0,
    max: data.max ? data.max : data.data + 10,
    type: 'gauge',
    axisLine: {
      lineStyle: {
        width: 20,
        color: data.colorRange ? data.colorRange : [
          [0.3, '#67e0e3'],
          [0.7, '#37a2da'],
          [1, '#fd666d']
        ]
      }
    },
    pointer: {
      itemStyle: {
        color: 'auto'
      }
    },
    axisTick: {
      distance: -30,
      length: 8,
      lineStyle: {
        color: '#fff',
        width: 2
      }
    },
    splitLine: {
      distance: -30,
      length: 30,
      lineStyle: {
        color: '#fff',
        width: 4
      }
    },
    axisLabel: {
      color: 'auto',
      distance: 0,
      fontSize: 12
    },
    detail: {
      valueAnimation: true,
      formatter: '{value} ' + data.unit ? data.unit : '',
      color: 'auto',
      fontSize: 25
    },
    data: [{
      value: data.data
    }]
  }]
}

export function getIndexGaugeSeries(style) {
  let series: echarts.EChartOption.SeriesGauge = {
    min: 0,
    max: 400,
    startAngle: 210,
    endAngle: -30,
    type: 'gauge',
    animation: true,
    splitNumber: 5,
    axisLine: {
      lineStyle: {
        width: 10,
        color: [
          [0.125, '#00E400'],
          [0.25, '#FFFF00'],
          [0.375, '#FF7E00'],
          [0.5, '#FF0000'],
          [0.75, '#99004C'],
          [1, '#7E0023']
        ]
      }
    },
    pointer: {
      show: true,
      width: 4,
      length: '75%'
    },
    axisTick: {
      show: false,
      length: 4,
      lineStyle: {
        color: '#fff',
        width: 2
      }
    },
    splitLine: {
      show: false,
      length: 14,
      lineStyle: {
        color: '#fff',
        width: 4
      }
    },
    axisLabel: {
      distance: 0,
      fontSize: style.fontSize - 2
    },
    detail: {
      formatter: '{c|{value}}',
      offsetCenter: [0, '60%'],
      color: '#101010',
      fontSize: style.fontSize + 2,
      rich: {
        a: {
          fontSize: style.fontSize,
          color: '#101010',
          verticalAlign: 'middle',
          lineHeight: style.fontSize + 4,
        },
        b: {
          fontSize: style.fontSize - 2,
          color: '#101010',
          lineHeight: style.fontSize + 4,
          verticalAlign: 'middle'
        },
        c: {
          fontSize: style.fontSize + 10,
        }
      }
    },

    data: []
  }
  return series;
}
// 获取指数环形图
export function getIndexPieSeries(style) {
  let indexPieSeries: echarts.EChartOption.SeriesPie = {
    name: '',
    legendHoverLink: false,
    type: 'pie',
    radius: ['60%', '70%'],
    hoverAnimation: false,
    clockwise: true,
    startAngle: 90,
    silent: false,
    cursor: 'default',
    label: {
      show: true,
      position: 'center',
      rich: {
        level1: {
          fontSize: style.fontSize + 16,
          // fontSize: 28,
          color: '#101010',
          verticalAlign: 'bottom',
          lineHeight: style.fontSize + 20
          // height: style.fontSize + 20
        },
        level2: {
          fontSize: style.fontSize + 4,
          // fontSize: 16,
          color: '#101010',
          verticalAlign: 'middle',
          lineHeight: style.fontSize + 10
        },
        level3: {
          fontSize: style.fontSize,
          color: '#101010',
          verticalAlign: 'bottom',
          lineHeight: style.fontSize + 4
        },
        unit: {
          fontSize: style.fontSize - 2,
          verticalAlign: 'middle',
          color: '#8e8e8e'
        },
        unitLeve1: {
          fontSize: style.fontSize,
          verticalAlign: 'bottom',
          color: '#8e8e8e',
        }
      }
    },
    emphasis: {
      label: {
        show: true
      }
    },
    labelLine: {
      show: false
    },
    data: [
      {
        name: '值',
        value: 0,
        itemStyle: {
          color: 'auto'
        },
        emphasis: {
          label: {
            show: true
          },
          itemStyle: {
            color: 'auto'
          }
        },
      },
      {
        value: 0,
        name: '剩余值',
        label: {
          show: false,
          fontSize: style.fontSize
        },
        itemStyle: {
          color: '#E6E6FA'
        },
        emphasis: {
          itemStyle: {
            color: '#E6E6FA'
          }
        }

      },
    ]
  }
  return indexPieSeries;
}
// 获取进度条环形图
export function getProgressPieSeries(style) {
  let progressPieSeries: echarts.EChartOption.SeriesPie = {
    name: '',
    legendHoverLink: false,
    type: 'pie',
    radius: ['60%', '70%'],
    hoverAnimation: false,
    clockwise: true,
    startAngle: 225,
    silent: false,
    cursor: 'default',
    label: {
      show: true,
      position: 'center',
      rich: {
        level1: {
          fontSize: style.fontSize + 16,
          // fontSize: 28,
          color: '#101010',
          verticalAlign: 'bottom',
          lineHeight: style.fontSize + 20
          // height: style.fontSize + 20
        },
        level2: {
          fontSize: style.fontSize + 4,
          // fontSize: 16,
          color: '#101010',
          verticalAlign: 'middle',
          lineHeight: style.fontSize + 10
        },
        level3: {
          fontSize: style.fontSize,
          color: '#101010',
          verticalAlign: 'bottom',
          lineHeight: style.fontSize + 4
        },
        unit: {
          fontSize: style.fontSize - 2,
          verticalAlign: 'middle',
          color: '#8e8e8e'
        },
        unitLeve1: {
          fontSize: style.fontSize,
          verticalAlign: 'bottom',
          color: '#8e8e8e',
        }
      }
    },
    emphasis: {
      label: {
        show: true
      }
    },
    labelLine: {
      show: false
    },
    data: [
      {
        name: '值',
        value: 0,
        itemStyle: {
          color: 'auto'
        },
        emphasis: {
          label: {
            show: true
          },
          itemStyle: {
            color: 'auto'
          }
        },
      },
      {
        value: 0,
        name: '剩余值',
        label: {
          show: false,
          fontSize: style.fontSize
        },
        itemStyle: {
          color: '#E6E6FA'
        },
        emphasis: {
          itemStyle: {
            color: '#E6E6FA'
          }
        }

      },
      {
        value: 0,
        name: '空白值',
        label: {
          show: false,
          fontSize: style.fontSize
        },
        itemStyle: {
          color: '#ffffff00'
        },
        emphasis: {
          itemStyle: {
            color: '#ffffff00'
          }
        }
      }
    ]
  }
  return progressPieSeries;
}

export function getDefaultPieChartSeries(style) {
  let pieChartSeries: echarts.EChartOption.SeriesPie = {
    name: '',
    type: 'pie',
    center: ['50%', '50%'],
    radius: '60%',
    hoverOffset: 0,
    avoidLabelOverlap: false,
    label: {
      show: true,
      fontSize: style.fontSize,
      fontWeight: 600
    },
    emphasis: {
      label: {
        show: true,
      }
    },
    labelLine: {
      show: true,
      length: 5,
      length2: 5
    },
    data: []
  }
  return pieChartSeries;
}